import { createFeatureSelector } from '@ngrx/store'
import { FeaturesState, FEATURE_NAME } from './features.state'

//console.log('[FEATURES.SELECTORS] Loading features.selectors.ts')
//console.log('[FEATURES.SELECTORS] FEATURE_NAME:', FEATURE_NAME)

/**
 * Root feature selector for the features state.
 * Separated from features.state.ts to avoid circular dependencies
 * and module initialization timing issues.
 */
export const selectFeatures = createFeatureSelector<FeaturesState>(FEATURE_NAME)

//console.log('[FEATURES.SELECTORS] selectFeatures created:', selectFeatures)
